module.exports = __webpack_public_path__ + "static/media/quote_1.f6ca71e6.png";